import { render, staticRenderFns } from "./BasisLocked.vue?vue&type=template&id=1b40b270&scoped=true&"
import script from "./BasisLocked.vue?vue&type=script&lang=js&"
export * from "./BasisLocked.vue?vue&type=script&lang=js&"
import style0 from "./BasisLocked.vue?vue&type=style&index=0&id=1b40b270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40b270",
  null
  
)

export default component.exports